module.exports = __webpack_public_path__ + "img/img_slide_10.e2bc02e9.webp";